

var init = function (element) {
    var defaultSettings = {
        startAt: 0,
        perView: 1,
        type: 'carousel'
    }
    var id = element.dataset.glide;
    var settingsAttr = element.dataset.glideSettings;
    var settings = settingsAttr ? JSON.parse(settingsAttr) : {}

    var glide = new Glide('#' + id, {
        ...defaultSettings,
        ...settings.settings
    }).mount();

    window.glide_component = window.glide_component || {}
    window.glide_component['' + id + ''] = glide;

    if (settings.asNavFor) {
        var asNavFor = window.glide_component['' + settings.asNavFor + ''];

        console.log('glide', glide);

        // glide.on('run', (a, b) => {
        //     console.log('move called', glide.index, asNavFor, asNavFor.go, `=${glide.index}`);
        //     asNavFor.go(`=${glide.index}`)
        //     // this.__changeActiveProject(glide.index)
        // })


        var thumbnails = element.querySelectorAll('[data-glide-nav-item]');

        thumbnails.forEach((el, index) => {
            el.addEventListener('click', function (e) {
                console.log('el', el.dataset)
                var index = el.dataset.glideNavItem;
                e.preventDefault();
                asNavFor.go(`=${index}`)
                glide.go(`=${index}`)

            });
        });
    }
}

var components = document.querySelectorAll('[data-glide]');

if (components) {
    for (var i = 0; i < components.length; i++) {
        var j = components[i];
        init(j)
    }
}